module.exports = __webpack_public_path__ + "static/media/board_view_campus_img_h.2d0b559e.png";